import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const AppSettingsNRO = lazy(() =>
  import("@scenes/AppSettings/AppSettings").then((module) => ({
    default: module.AppSettings,
  }))
);

export const appSettingsNRO: NavigationRoutingObject = {
  Component: AppSettingsNRO,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("app-settings-menu-option", "App Settings"),
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("sdk_entitlement");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("app-settings-developer-console", "Developer Console")],
      description: t("previously-developer-console", 'Previously in "Developer Console"'),
    },
    {
      keywords: [
        t("app-settings-alt-keyword-1", "Push Notification Settings"),
        t("app-settings-alt-keyword-2", "SDK Authentication"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/app_settings/app_settings/:appGroupId",
};
